import AgencyForm from 'client/common/components/agency-form';

export default AgencyForm;
